import Joyride, { Step, STATUS } from "react-joyride";
import { useEditor } from "../contexts/EditorContext";
import { TooltipBody } from "./TooltipBody";
import { useHistory } from "react-router-dom";
import { useStorage } from "../contexts/StorageContext";
import { useTranslation } from "react-i18next";
import { sendEvent } from "../../helpers/tracking";

export function WalkThrough() {
  const { showProductTour } = useEditor();
  const history = useHistory();
  const { video } = useStorage();
  const { t } = useTranslation();
  const tourSteps: Step[] = [
    {
      target: "#themis-scene-editor",
      title: t("tooltip_sequence.title"),
      content: t("tooltip_sequence.description"),
      placement: "bottom",
      floaterProps: {
        hideArrow: true,
        styles: {
          floaterWithAnimation: {
            transition: "opacity 0.9s ease 0.5s",
          },
          floater: {
            filter: "drop-shadow(rgba(0, 0, 0, 0.2) 0px 0px 6px)",
          },
        },
      },
      disableBeacon: true,
    },
    {
      target: "#themis-timeline",
      title: t("tooltip_timeline.title"),
      content: t("tooltip_timeline.description"),
      placement: "right",
      styles: {
        options: {
          arrowColor: "#fff",
        },
      },
      floaterProps: {
        styles: {
          floaterWithAnimation: {
            transition: "opacity 0.9s ease 0.5s",
          },
          floater: {
            filter: "drop-shadow(rgba(0, 0, 0, 0.2) 0px 0px 6px)",
          },
        },
      },
      disableBeacon: true,
    },
    {
      target: "#themis-tools",
      title: t("tooltip_tools.title"),
      styles: {
        options: {
          arrowColor: "#fff",
        },
      },
      floaterProps: {
        styles: {
          floaterWithAnimation: {
            transition: "opacity 0.9s ease 0.5s",
          },
          floater: {
            filter: "drop-shadow(rgba(0, 0, 0, 0.2) 0px 0px 6px)",
          },
        },
      },
      content: t("tooltip_tools.description"),
      placement: "left",
      disableBeacon: true,
    },
    {
      target: "#themis-canvasSettings",
      title: t("tooltip_canvasSettings.title"),
      styles: {
        options: {
          arrowColor: "#fff",
        },
      },
      floaterProps: {
        styles: {
          floaterWithAnimation: {
            transition: "opacity 0.9s ease 0.5s",
          },
          floater: {
            filter: "drop-shadow(rgba(0, 0, 0, 0.2) 0px 0px 6px)",
          },
        },
      },
      placement: "bottom",
      content: t("tooltip_canvasSettings.description"),
      disableBeacon: true,
    },
    {
      target: "#themis-collaborators",
      title: t("tooltip_share.title"),
      styles: {
        options: {
          arrowColor: "#fff",
        },
      },
      floaterProps: {
        styles: {
          floaterWithAnimation: {
            transition: "opacity 0.9s ease 0.5s",
          },
          floater: {
            filter: "drop-shadow(rgba(0, 0, 0, 0.2) 0px 0px 6px)",
          },
        },
      },
      content: t("tooltip_share.description"),

      disableBeacon: true,
    },
    {
      target: "#themis-feedback",
      title: t("tooltip_feedback.title"),
      content: t("tooltip_feedback.description"),
      disableBeacon: true,
      floaterProps: {
        styles: {
          floaterWithAnimation: {
            transition: "opacity 0.9s ease 0.5s",
          },
          floater: {
            filter: "drop-shadow(rgba(0, 0, 0, 0.2) 0px 0px 6px)",
          },
        },
      },
      styles: {
        tooltipTitle: {
          paddingRight: "10px",
        },
      },
    },
  ];

  return (
    <>
      <Joyride
        run={showProductTour}
        steps={tourSteps}
        continuous
        showSkipButton={false}
        showProgress={true}
        disableOverlay={false}
        tooltipComponent={TooltipBody}
        callback={(data) => {
          const finishedStatuses: string[] = [STATUS.FINISHED];

          if (finishedStatuses.includes(data.status)) {
            sendEvent("Product Tour Completed");

            history.push({ pathname: `/video-editor/${video?.uuid}` });
          }
        }}
      />
    </>
  );
}
